/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-02 10:35:22
 * @Description: file content
 */
//徐洋的
import React, { Component } from 'react';
import TZDatePickClientTime from '../TZDatePickClientTime';
import { getSysFieldid } from '@platform/api';
require('./index.less');

class DateTimePickerBetween extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
        };
    }
    componentWillReceiveProps(nextProps) {
        // this.state.value = nextProps.value;
        this.setState({ value: nextProps.value });
    }
    render() {
        let { fieldid, dropdownClassName, dateInputPlaceholder, mustFill, ...others } = this.props;

        if (getSysFieldid(fieldid)) {
            dropdownClassName = dropdownClassName ? dropdownClassName + ` fieldid_${fieldid}_calendar` : ` fieldid_${fieldid}_calendar`;
        }
        return (
            <div className="datepickerbetween" fieldid={getSysFieldid(fieldid)}>
                <div className="startDateTime datepickerbetween-item">
                    <TZDatePickClientTime
                        {...others}
                        //format={['YYYY-MM-DD hhmmss']}
                        dateInputPlaceholder={dateInputPlaceholder || 'YYYYMMDD hh:mm:ss'}
                        dropdownClassName={dropdownClassName}
                        value={this.state.value && this.state.value[0]}
                        onChange={this.props.onChange && this.props.onChange.bind(this, 0)}
                        className={`DateTimePickerBetween ${this.props.className}`}
                    />
                </div>
                <div className="line">-</div>
                {mustFill}
                <div className="endDateTime datepickerbetween-item">
                    <TZDatePickClientTime
                        {...others}
                        //format={['YYYY-MM-DD hhmmss']}
                        dateInputPlaceholder={dateInputPlaceholder || 'YYYYMMDD hh:mm:ss'}
                        dropdownClassName={dropdownClassName}
                        value={this.state.value && this.state.value[1]}
                        onChange={this.props.onChange && this.props.onChange.bind(this, 1)}
                        className={`DateTimePickerBetween ${this.props.className}`}
                    />
                </div>
            </div>
        );
    }
}

export default DateTimePickerBetween;
